import { render } from "./CustomerInvoiceInfo.vue?vue&type=template&id=c2e6e8c2&scoped=true"
import script from "./CustomerInvoiceInfo.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceInfo.vue?vue&type=script&lang=js"

import "./CustomerInvoiceInfo.vue?vue&type=style&index=0&id=c2e6e8c2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e6e8c2"]])

export default __exports__